import React from 'react';
import Script from 'react-load-script';
import {connect} from 'react-redux';
import { handleScriptLoad, handleScriptError, handleScriptCreate } from './script-loader-actions.js';

/**
 * Script loader loaders scripts and store in redux. 
 * This is to prevent the script resource being fetched several times on a SPA
 */
class ScriptLoader extends React.Component {
    constructor(props) {
        super(props);
    }

    onCreate = () => {
        let { name , url } = this.props;
        let reduxKey = name || url;
        this.props.handleScriptCreate(reduxKey);
    }

    onError = () => {
        let { name , url } = this.props;
        let reduxKey = name || url;
        this.props.handleScriptError(reduxKey);
    }

    onLoad = () => {
        let { name , url } = this.props;
        let reduxKey = name || url;
        this.props.handleScriptLoad(reduxKey);
    }


    render() {
        const { url, attributes } = this.props;
        
        return(
                !this.props.scriptLoaded &&
                    <Script
                        url={url}
                        onCreate={this.onCreate}
                        onError={this.onError}
                        onLoad={this.onLoad}
                        attributes={attributes}
                    />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { scriptLoader } = state;
    let { name , url } = ownProps;
    let reduxKey = name || url;
	return { scriptLoaded: scriptLoader[reduxKey] }
};

const mapDispatchToProps = (dispatch) => {
	return {
		handleScriptLoad: (name) => dispatch(handleScriptLoad(name)),
        handleScriptCreate: (name) => dispatch(handleScriptCreate(name)),
        handleScriptError: (name) => dispatch(handleScriptError(name))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScriptLoader);
